import { useTranslation } from 'react-i18next'
import { Button } from '#components/Button'
import { Icon } from '#components/Icon'
import { toastError } from '#features/ErrorHandling/toastError'
import { signInRedirect } from '#features/User/userManager'
import ExitIcon from '#icons/exit-48.svg'
import { largeIconPageClass } from './style'

export const SignedOutPage = () => {
  const { t } = useTranslation('shared')

  return (
    <div className={largeIconPageClass}>
      <Icon className="_icon" iconUrl={ExitIcon} size="xxl" />

      <p className="_subtitle">{t('user.signed-out.message', 'You have been signed out. This page can be safely closed now')}</p>
      <section>
        <Button
          onClick={() => {
            void signInRedirect().catch(toastError)
          }}
        >
          {t('user.signed-out.actions.sign-in-again', 'Sign In Again')}
        </Button>
      </section>
    </div>
  )
}
